var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('artisio-modal',{attrs:{"size":"md","visible":_vm.modal.show,"title":_vm.$t("DPV Description"),"hide-footer":true,"scrollable":""},on:{"hidden":_vm.hideDescriptionModal}},[_vm._v("\n  "+_vm._s(_vm.modal.description)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }